import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CardStatusPaymentRegion } from '../../../../../queries/pxtraCard';

export const PaymentRegionCell: FC<{ region: CardStatusPaymentRegion | null }> = ({ region }) => {
  const { t } = useTranslation();

  if (!region) {
    return (
      <Typography variant="body2" color="error.main" className="whitespace-nowrap">
        {t('pxtraCard:regionNotChosen')}
      </Typography>
    );
  }

  return (
    <Box className="flex flex-col whitespace-nowrap">
      <Typography variant="body2" className="leading-4">
        {region.postal_code} {region.city}
      </Typography>
      <Typography variant="caption" color="grey.600" className="leading-4">
        {t('pxtraCard:regionWithNeighbours', {
          code: region.region_code,
          count: region.neighbor_count
        })}
      </Typography>
    </Box>
  );
};
